import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <p>&copy; 2026 Daanyaal Haroon. Built with passion and code.</p>
    </footer>
  );
}

export default Footer;
